import { ADD_ITEM_TO_BASKET } from 'Rentlio/state/types'
import {
  getTotalRate,
  getAverageRate
} from 'Rentlio/screen/accomodation/component/RatePlans/SingleRatePlan/helper/getTotalRate'
import { getTouristTax } from 'Rentlio/components/ReservationSummary/util/getTouristTax.js'
import getFirstNightPrice from 'Rentlio/utils/getFirstNightPrice'

export const addItemToBasket = (
  unitTypeId,
  ratePlanId,
  quantity,
  adults,
  childrenAges,
  isLoadedFromSession,
  amenities
) =>
  function (dispatch, getState) {
    const { unitTypes, services, fees, configuration } = getState()

    const selectedAmenities = amenities || configuration.selectedAmenities

    const selectedUnitType = unitTypes.find(unitType => unitType.unitTypeId === unitTypeId)

    if (selectedUnitType === undefined) {
      return
    }

    const selectedRatePlan = selectedUnitType.rates.find(ratePlan => ratePlan.ratePlanId === ratePlanId)

    if (selectedRatePlan === undefined) {
      return
    }

    const totalRate = getTotalRate(selectedUnitType, selectedRatePlan, adults, childrenAges)
    const averageRatePerNight = getAverageRate(selectedUnitType, selectedRatePlan, adults, childrenAges)

    const firstNightPrice = getFirstNightPrice(selectedUnitType, selectedRatePlan, adults, childrenAges)
    let totalRateBeforeTax = totalRate
    const { bookingEngine } = selectedUnitType

    if (bookingEngine.isVatRegistered && bookingEngine.vatRate > 0 && !selectedRatePlan.isTouristTaxIncluded) {
      totalRateBeforeTax = totalRate / (bookingEngine.vatRate / 100 + 1)
    }
    // if tourist tax is included in rate we need to reduct tourist tax price form total and then calculate VAT because vat is not paid on tourist tax.
    // Use the rate plan's own dailies (its property's rates) - the store-level touristTaxes is
    // the union across a group engine's properties and would price a sibling property's tax here
    if (bookingEngine.isVatRegistered && bookingEngine.vatRate > 0 && selectedRatePlan.isTouristTaxIncluded) {
      totalRateBeforeTax =
        (totalRate - getTouristTax(selectedRatePlan.includedTouristTaxes, adults, childrenAges)) /
        (bookingEngine.vatRate / 100 + 1)
    }

    return dispatch({
      type: ADD_ITEM_TO_BASKET,
      quantity: quantity,
      payload: {
        isLoadedFromSession: isLoadedFromSession || false,
        bookingEngineId: selectedUnitType.bookingEngine.id,
        unitTypeId: selectedUnitType.unitTypeId,
        currency: selectedUnitType?.bookingEngine?.currency,
        isVatRegistered: selectedUnitType?.bookingEngine?.isVatRegistered,
        vatRate: selectedUnitType?.bookingEngine?.vatRate,
        unitTypeName: selectedUnitType.unitTypeName,
        description: selectedUnitType.description,
        images: selectedUnitType.images,
        ratePlanId: selectedRatePlan.ratePlanId,
        ratePlanName: selectedRatePlan.ratePlanName,
        totalRate: totalRate,
        totalRateBeforeTax: totalRateBeforeTax,
        averageRatePerNight: averageRatePerNight,
        firstNightPrice: firstNightPrice,
        adults: adults,
        childrenAges: childrenAges,
        cancellationPolicy: selectedRatePlan.policy,
        checkInBegin: selectedUnitType?.checkInBegin,
        checkInEnd: selectedUnitType?.checkInEnd,
        checkOutBegin: selectedUnitType?.checkOutBegin,
        checkOutEnd: selectedUnitType?.checkOutEnd,
        includedServices: selectedRatePlan.includedServices || [],
        fees: fees
          .filter(
            ({ ratePlanIds, unitTypeIds }) =>
              (ratePlanIds.length === 0 || ratePlanIds.includes(selectedRatePlan.ratePlanId)) &&
              (unitTypeIds.length === 0 || unitTypeIds.includes(selectedUnitType.unitTypeId))
          )
          .map(fee => ({ ...fee })),
        services: services
          .filter(service => service.bookingEngineId === selectedUnitType.bookingEngine.id)
          .map(service => {
            return {
              id: service.id,
              paymentType: service.paymentType,
              name: service.name,
              description: service.description,
              priceBeforeTax: service.priceBeforeTax,
              price: service.priceAfterTax,
              isMandatory: service.isMandatory,
              quantity: service.isMandatory ? 1 : 0,
              pricingType: service.pricingType,
              pricingDynamic: service.pricingDynamic,
              childrenDifferentThanAdults: service.childrenDifferentThanAdults,
              childrenCategories: service.childrenCategories,
              dailyPrices: service.dailyPrices
            }
          }),
        // if we have tourist tax included in rate we will not display tourist tax price on BE side, we will calculate accommodation and tourist tax on webapp side.
        // The rate plan's dailies are its own property's - the store-level union across a group
        // engine's properties would show a sibling property's tax here
        touristTax: getTouristTax(selectedRatePlan.includedTouristTaxes, adults, childrenAges),
        isTouristTaxIncluded: selectedRatePlan.isTouristTaxIncluded,
        amenities: selectedAmenities,
        activePromoCode: selectedRatePlan.activePromoCode || null
      }
    })
  }
